import {useEffect, useRef} from 'react';

export const useMockPromise = (timeout = 1000) => {
  const timeoutRef = useRef<NodeJS.Timeout>();
  const mockPromise = () =>
    new Promise(resolve => {
      timeoutRef.current = setTimeout(() => {
        resolve(true);
      }, timeout);
    });

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return mockPromise;
};
